/**
 * Логотип GPS Tracker.
 *
 * Знак повторяет логику маршрута: лаймовый пройденный участок,
 * фиолетовая цель. Тот же визуальный язык, что на карте и в оверлее.
 */

interface LogoProps {
  /** Компактный режим: только знак и название без подписи. */
  compact?: boolean;
  className?: string;
}

export function Logo({ compact = false, className = '' }: LogoProps) {
  return (
    <span className={`flex items-center gap-2.5 ${className}`}>
      <svg
        viewBox="0 0 32 32"
        className="h-8 w-8 shrink-0"
        role="img"
        aria-label="GPS Tracker"
      >
        <rect width="32" height="32" rx="7" fill="#080F20" stroke="#20345D" />
        <path
          d="M7 24 C 11 24, 11 16, 16 16"
          fill="none"
          stroke="#AFFF00"
          strokeWidth="2.5"
          strokeLinecap="round"
        />
        <path
          d="M16 16 C 21 16, 21 9, 25 9"
          fill="none"
          stroke="#9146FF"
          strokeWidth="2.5"
          strokeLinecap="round"
          strokeDasharray="3 3"
        />
        <circle cx="7" cy="24" r="2.75" fill="#AFFF00" />
        <circle cx="25" cy="9" r="2.75" fill="#9146FF" />
      </svg>

      <span className="flex min-w-0 flex-col leading-none">
        <span className="text-sm font-extrabold uppercase tracking-[0.14em] text-ink">
          GPS Tracker
        </span>
        {compact ? null : (
          <span className="mt-1 font-mono text-[0.625rem] uppercase tracking-[0.18em] text-muted">
            Live route telemetry
          </span>
        )}
      </span>
    </span>
  );
}
